export default {
  PRE_CONDITION_FAILED: 412,
  UNAUTHORIZED: 401,
};
